var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ListboxOption, ListboxList, ListboxPopover, ListboxInput, ListboxButton, } from "@reach/listbox";
import { Chevron } from "@react-components/primitives/Icons/Icons";
import { ConditionalWrap } from "@react-components/primitives/ConditionalWrap/ConditionalWrap";
var SelectButton = function (_a) {
    var button = _a.button, otherProps = __rest(_a, ["button"]);
    return (_jsx(ListboxButton, __assign({ className: "select__button" }, otherProps, { children: function (_a) {
            var value = _a.value, label = _a.label, isExpanded = _a.isExpanded;
            return (_jsxs("div", { className: "select__button-inner ".concat(isExpanded ? "select__button-inner--open" : ""), children: [button ? button({ value: value, label: label }) : _jsx("span", { children: label }), _jsx(Chevron, {})] }));
        } })));
};
var SelectInput = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(ListboxInput, __assign({ className: "select" }, otherProps, { children: children })));
};
var SelectPopover = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(ListboxPopover, __assign({ className: "select select--popover" }, otherProps, { children: children })));
};
var SelectList = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(ListboxList, __assign({ className: "select__list" }, otherProps, { children: children })));
};
var Select = React.forwardRef(function Select(_a, ref) {
    var button = _a.button, children = _a.children, selectListClass = _a.selectListClass, otherProps = __rest(_a, ["button", "children", "selectListClass"]);
    return (_jsxs(SelectInput, __assign({}, otherProps, { 
        /* pretty much impossible to have multiple libs with their own box-primitives, agree on interfaces */
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        ref: ref, children: [_jsx(SelectButton, __assign({}, (button && { button: button }))), _jsx(SelectPopover, { children: _jsx(ConditionalWrap, { condition: !!selectListClass, wrap: function (children) { return (_jsx("div", { className: selectListClass, children: children })); }, children: _jsx(SelectList, { children: children }) }) })] })));
});
var Option = function (_a) {
    var children = _a.children, otherProps = __rest(_a, ["children"]);
    return (_jsx(ListboxOption, __assign({ className: "select__option" }, otherProps, { children: children })));
};
export { Select, Option };
